import { ComposedTheme } from '@glu/theming';

/* istanbul ignore file */
export default ({ palette, typography }: ComposedTheme) => ({
  checkboxLabel: {
    ...typography.text,
    color: palette.text.dark,
    display: 'inline',
    fontSize: 14,
    marginLeft: 6,
  },
  checkboxRadio: {
    borderColor: palette.grey.G400,
    checkColor: palette.text.light,
    dark: {
      borderColor: palette.text.light,
      checkColor: palette.primary.dark,
      selectedColor: palette.text.light,
    },
    selectedColor: palette.primary.normal,
    shadowColor: palette.grey.G400,
  },
  checkboxRadioSvgDisplay: 'inline-block',
  container: {
    marginBottom: 20,
  },
  dark: {
    color: palette.text.light,
    error: {
      borderColor: palette.form.error,
      color: palette.form.error,
    },
    warning: {
      borderColor: palette.form.warning || palette.error,
      color: palette.form.warning || palette.error,
    },
  },
  disabled: {
    cursor: 'no-drop',
  },
  error: {
    borderColor: palette.form.error,
    color: palette.form.error,
    fontFamily: typography.fontFamily,
    fontSize: 12,
    fontWeight: 'normal',
    iconDisplay: 'none',
  },
  helpText: {
    color: palette.text.midGray,
    dark: {
      color: palette.text.light,
    },
  },

  // CheckboxRadio
  hiddenCheckbox: {},

  input: {
    '-o-transition': 'border-color ease-in-out .15s, box-shadow ease-in-out .15s',
    '-webkit-box-shadow': 'inset 0 1px 1px rgba(0, 0, 0, 0.075)',
    '-webkit-transition': 'border-color ease-in-out .15s, box-shadow ease-in-out .15s',
    backgroundColor: 'inherit',
    backgroundImage: 'none',
    border: `1px solid ${palette.form.border}`,
    borderRadius: 4,
    boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075)',
    color: palette.text.dark,
    dark: {
      backgroundColor: 'inherit',
    },
    darkColor: palette.text.light,
    darkFocusColor: palette.focus.dark,
    focusColor: palette.focus.normal,
    fontSize: 14,
    height: 34,
    lineHeight: 1.42857143,
    padding: [6, 12],
    textareaHeight: 60,
    transition: 'border-color ease-in-out .15s, box-shadow ease-in-out .15s',
  },

  label: {
    ...typography.label,
    color: palette.text.dark,
    paddingRight: 5,
  },

  numberFirstButton: {
    borderRadius: [0, 4, 0, 0],
  },

  numberInput: {
    borderRadius: [4, 0, 0, 4],
  },

  numberLastButton: {
    borderRadius: [0, 0, 4, 0],
  },

  // SelectBase
  select: {
    caret: {
      borderLeft: '4px solid transparent',
      borderRight: '4px solid transparent',
      borderTop: '4px dashed',
      height: 0,
      pointerEvents: 'none',
      position: 'absolute',
      right: 10,
      top: 16,
      width: 0,
    },
    caretIcon: 'none',
    caretRight: 10,
    caretTop: 9,
    darkFocusColor: palette.focus.dark,
    darkIconFill: palette.text.light,
    darkOptionBackground: palette.primary.darkBackground,
    darkOptionColor: palette.text.light,
    focusColor: palette.focus.normal,
    iconFill: palette.text.dark,
    optionBackground: palette.background,
    optionColor: palette.text.dark,
    padding: [9, 30, 9, 10],
  },

  warning: {
    borderColor: palette.error,
    color: palette.error,
  },
});
